/**
 * Taken from https://github.com/NerdWallet/nw-client-lib/blob/master/src/tracking/components/element-impression-interaction.jsx
 * Needed to change impressionHeader property name to elementImpressionHeader in order to work.
 */
// eslint-disable-next-line lodash/import-scope
import { get } from 'lodash';
import { connect } from 'react-redux';

import { ElementInteraction } from '@nerdwallet/nw-client-lib/tracking';

export default connect((state, ownProps) => ({
  impressionId: get(
    state,
    `impressions[${ownProps.id}].elementImpressionHeader.impressionId`
  ),
}))(ElementInteraction);
